const en_mitra_stock_req = {
    "": "item request",
    detail: "item request detail",
    add: "add item request",
    edit: "edit item request",

    do_out: "create item out",
    do_in: "create item in",

    label: {
        requested_dest: "Select Request Destination",
        requested_qty: "requested qty",
        date: "Target Delivery Date",
    },

    print: {
        title: 'Stock Request Details',
        request_number: "request number",
        requested_by: 'requested by',
        requested_from: 'requested from',
    },

    message: {
        delete_title: "Are you sure you want to cancel the stock request?",
        delete_text: "Enter the reason for canceling the stock request.",
        reject_title: "Are you sure you want to reject the stock request?",
        reject_text: "Enter the reason for rejecting the stock request.",
    },

    error: {
        create: "Failed to create the stock request",
        edit: "Failed to update the stock request",

        done: "Failed to complete the stock request",
        delete: "Failed to delete the stock request",
        reject: "Failed to reject the stock request",
        approve: "Failed to confirm the stock request",

        date: "Target delivery date is required",
        mitra_dest: "Request destination is required",
    },

    success: {
        create: "Stock request created successfully",
        edit: "Stock request updated successfully",

        done: "Stock request completed successfully",
        delete: "Stock request deleted successfully",
        reject: "Stock request rejected successfully",
        approve: "Stock request confirmed successfully",
    },
}

export default en_mitra_stock_req;